<template>
  <div>
    <title-component :size="1" :lineSeparator="'under'">
      <translate>Welcome to the new application for certification at Kiwa Certification</translate>
    </title-component>
    <!-- Page texts -->
    <p v-translate>
      The following links lead to a new application for the respective certification.
      These are only for people who are not yet a customer of Kiwa.
    </p>
    <p class="p-text">
      <span v-translate>
        If you are a former customer and wish to apply for renewal or new certification,
        you must first login to the portal.
      </span>
      <br/>
      <router-link class="login-link is-success" :to="{ name: 'LoginView'}" v-translate>
        Go to the login page
      </router-link>
    </p>
    <!-- Applications list -->
    <div v-for="(service, key) in getAppliableServices" :key="key" class="application">
      <div class="has-text-weight-bold">
        {{ service.name }} {{ service.shortName }}
      </div>
      <p>
        {{ service.description }}
      </p>
      <router-link
        class="button is-uppercase is-success is-outlined"
        :to="{ name: 'ApplicationView', params: { code: service.code } }"
        v-translate>
        Apply
      </router-link>
    </div>
    <!-- Browser compatiblity check -->
    <browser-compatibility-component />
  </div>
</template>

<script>
  import { mapActions, mapGetters, mapState } from 'vuex'
  import TitleComponent from '@/components/layout/TitleComponent.vue'
  import { onKeyEnterMixin, setContainedHeightMixin } from '@/mixins/mixins'
  import BrowserCompatibilityComponent from '@/components/layout/BrowserCompatibilityComponent'

  export default {
    name: 'reset-password-view',
    mixins: [onKeyEnterMixin, setContainedHeightMixin],
    data () {
      return {
        submitRequest: null
      }
    },
    components: {
      TitleComponent,
      BrowserCompatibilityComponent
    },
    computed: {
      ...mapState({
        services: state => state.serviceModule.services
      }),
      ...mapGetters([
        'getAppliableServices'
      ])
    },
    methods: {
      ...mapActions([
        'getServices'
      ])
    },
    created () {
      this.getServices().catch((err) => {
        this.handleError(err)
      })
    }
  }
</script>

<style lang="sass" scoped>
  .p-text
    margin-top: 1rem
    span:first()
      display: inline-block
      margin-rigth: 0.2rem
  .application
    margin-top: 2rem
    .button
      margin-top: 0.5rem
</style>
